import { useEffect } from "react";

export default function DrawerWrapper({ children, visible }) {
  // Manage body scroll lock
  useEffect(() => {
    document.body.classList.toggle("lock-scroll", visible);
  }, [visible]);

  return children;
}
